import { Routes } from '@angular/router';
import { AuthorizeAccessGuard } from '@app/guards/authorize-access.guard';
import { Roles } from '@app/common/roles';

export const DEFAULT_MODAL_ROUTE_CONFIG: Routes = [
  {
    path: 'user-app-tiles',
    outlet: 'modal',
    loadChildren: () => import('@app/components/apps-and-tools/dialogs/user-app-tile-add-edit/user-app-tile-modal-view.module').then(m => m.UserAppTileModalViewModule),
  },
  {
    path: 'app-tile-intro',
    outlet: 'modal',
    loadChildren: () => import('@app/components/apps-and-tools/dialogs/apps-and-tools-dialog-intro/apps-and-tools-intro-modal-view.module').then(m => m.AppsAndToolsDialogIntroModalModule),
  },
  {
    path: 'app-tiles',
    outlet: 'modal',
    loadChildren: () => import('@app/components/apps-and-tools/dialogs/app-tile-add-edit/app-tile-modal-view.module').then(m => m.AppTileModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.AppEditor, Roles.Editor] }
  },
  {
    path: 'broadcast-messages',
    outlet: 'modal',
    loadChildren: () => import('@app/views/broadcast-messages/broadcast-messages-modal-view.module').then(m => m.BroadcastMessagesModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.MessageBroadcastEditor, Roles.Editor] }
  },
  {
    path: 'audits',
    outlet: 'modal',
    loadChildren: () => import('@app/views/audits/audits-modal-view.module').then(m => m.AuditsViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
  },
  {
    path: 'find-information',
    outlet: 'modal',
    loadChildren: () => import('@app/components/find-information/find-information-light-menu/find-information-light-dialog/find-information-modal-view.module').then(m => m.FindInformationModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
  },
  {
    path: 'resource-values',
    outlet: 'modal',
    loadChildren: () => import('@app/views/admin/resource-values/resource-values-modal-view.module').then(m => m.ResourceValuesModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin] }
  },
  {
    path: 'search',
    outlet: 'modal',
    loadChildren: () => import('@app/views/search/search-view.module').then(m => m.SearchModalViewModule)
  },
  {
    path: 'infoboxes',
    outlet: 'modal',
    loadChildren: () => import('@app/views/infobox/infobox-modal-view.module').then(m => m.InfoBoxModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
  },
  {
    path: 'power-bi',
    outlet: 'modal',
    loadChildren: () => import('@app/views/power-bi/power-bi-frames-modal-view.module').then(m => m.PowerBIModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.PowerBIEditor] }
  },
  {
    path: 'restaurants',
    outlet: 'modal',
    loadChildren: () => import('@app/views/restaurant-menu/restaurant-menu-modal-view.module').then(m => m.RestaurantMenuModalViewModule),
    canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
  }
];
